import styled from 'styled-components'

import { CoverImage } from '@redriverpress/system'

import { resultImageSize } from '../../constants/ui'

const HitImage = styled(CoverImage).attrs(props => ({
  src: props.src,
  alt: '',
  size: resultImageSize,
  mx: [undefined, null, 'auto'],
  mb: [3, null, 0],
}))``

HitImage.displayName = 'HitImage'

export default HitImage
